module.exports = __webpack_public_path__ + "img/bill.0a5cfb9e.svg";